"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OptionButton = require("./OptionButton");
Object.keys(_OptionButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OptionButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OptionButton[key];
    }
  });
});
var _SimpleOptionButton = require("./SimpleOptionButton");
Object.keys(_SimpleOptionButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SimpleOptionButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SimpleOptionButton[key];
    }
  });
});